<template>
  <div>
    <loading :active="loadingIsCompleted"> </loading>
    <cliente-layout :active="4">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="card-title">Receitas / Prescrições</h4>
            <button class="btn btn-primary" @click="showModal = true">
              <i class="fa fa-plus"></i> Nova Receita
            </button>
          </div>
          <div class="card-body">
            <div v-if="prescriptions.length === 0" class="text-center py-5">
              <i class="mdi mdi-file-document-outline" style="font-size: 4rem; color: #ccc;"></i>
              <p class="text-muted mt-3">Nenhuma receita cadastrada</p>
              <button class="btn btn-primary" @click="showModal = true">
                Cadastrar primeira receita
              </button>
            </div>

            <div class="table-responsive" v-else>
              <table class="table table-striped mb-0">
                <thead>
                  <tr>
                    <th>NOME</th>
                    <th>DESCRIÇÃO</th>
                    <th>DATA</th>
                    <th>ARQUIVO</th>
                    <th>AÇÕES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in prescriptions" :key="item.id">
                    <td><strong>{{ item.name }}</strong></td>
                    <td>{{ item.description || '-' }}</td>
                    <td>{{ formatDate(item.created_at) }}</td>
                    <td>
                      <a :href="item.file_url" target="_blank" class="btn btn-sm btn-info">
                        <i class="fa fa-download"></i> PDF
                      </a>
                    </td>
                    <td>
                      <button class="btn btn-sm btn-danger" @click="deletePrescription(item.id)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de Upload -->
      <div class="modal-overlay" v-if="showModal" @click.self="showModal = false">
        <div class="modal-content">
          <div class="modal-header">
            <h5>Nova Receita</h5>
            <button class="btn-close" @click="showModal = false">&times;</button>
          </div>
          <div class="modal-body">
            <div class="form-group mb-3">
              <label>Nome da Receita *</label>
              <input type="text" class="form-control" placeholder="Ex: Suplementação Proteica"
                v-model="newPrescription.name" />
            </div>
            <div class="form-group mb-3">
              <label>Descrição</label>
              <textarea class="form-control" placeholder="Descrição opcional..." rows="2"
                v-model="newPrescription.description"></textarea>
            </div>
            <div class="form-group mb-3">
              <label>Arquivo PDF *</label>
              <input type="file" class="form-control" accept=".pdf" ref="fileInput" @change="handleFileChange" />
              <small class="text-muted" v-if="selectedFileName">
                Arquivo selecionado: {{ selectedFileName }}
              </small>
            </div>
            <div class="form-group mb-3">
              <label>Data de Expiração (opcional)</label>
              <input type="date" class="form-control" v-model="newPrescription.expires_at" />
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showModal = false">Cancelar</button>
            <button class="btn btn-primary" @click="uploadPrescription"
              :disabled="uploading || !newPrescription.name || !fileBase64">
              {{ uploading ? 'Enviando...' : 'Salvar Receita' }}
            </button>
          </div>
        </div>
      </div>
    </cliente-layout>
  </div>
</template>

<script>
import ClienteLayout from "../../../components/Layouts/ClienteLayout.vue";
import api from "../../../services/funcoes-service";
import Loading from "../../../components/Layouts/Loading.vue";
import moment from "moment";

export default {
  components: {
    ClienteLayout,
    Loading,
  },
  data() {
    return {
      prescriptions: [],
      loadingIsCompleted: true,
      showModal: false,
      uploading: false,
      selectedFileName: "",
      fileBase64: null,
      newPrescription: {
        name: "",
        description: "",
        expires_at: ""
      }
    };
  },
  mounted() {
    this.getPrescriptions();
  },
  methods: {
    formatDate(date) {
      return moment(date).utc().format("DD/MM/YYYY");
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (file.type !== 'application/pdf') {
        this.$toast.error("Apenas arquivos PDF são permitidos!");
        return;
      }

      this.selectedFileName = file.name;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.fileBase64 = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    async getPrescriptions() {
      try {
        const clientId = this.$router.history.current.params.id;
        const response = await api.get(`/prescriptions/client/${clientId}`);

        if (response.data.error == 0) {
          this.prescriptions = response.data.prescriptions;
        }
        this.loadingIsCompleted = false;
      } catch (error) {
        this.$toast.error("Erro ao carregar receitas!");
        this.loadingIsCompleted = false;
      }
    },

    async uploadPrescription() {
      if (!this.newPrescription.name || !this.fileBase64) {
        this.$toast.error("Preencha o nome e selecione um arquivo PDF!");
        return;
      }

      this.uploading = true;

      try {
        const clientId = this.$router.history.current.params.id;
        const user = JSON.parse(localStorage.getItem('user'));

        const payload = {
          client_id: parseInt(clientId),
          user_id: user?.user?.id || null,
          name: this.newPrescription.name,
          description: this.newPrescription.description || null,
          file_base64: this.fileBase64,
          file_name: this.selectedFileName,
          expires_at: this.newPrescription.expires_at || null
        };

        const response = await api.post('/prescriptions', payload);

        if (response.data.error == 0) {
          this.$toast.success("Receita cadastrada com sucesso!");
          this.showModal = false;
          this.resetForm();
          this.getPrescriptions();
        } else {
          this.$toast.error(response.data.message || "Erro ao cadastrar receita!");
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Erro ao enviar receita!");
      } finally {
        this.uploading = false;
      }
    },

    async deletePrescription(id) {
      if (!confirm("Deseja realmente remover esta receita?")) return;

      try {
        const response = await api.delete(`/prescriptions/${id}`);

        if (response.data.error == 0) {
          this.$toast.success("Receita removida!");
          this.getPrescriptions();
        } else {
          this.$toast.error("Erro ao remover receita!");
        }
      } catch (error) {
        this.$toast.error("Erro ao remover receita!");
      }
    },

    resetForm() {
      this.newPrescription = {
        name: "",
        description: "",
        expires_at: ""
      };
      this.fileBase64 = null;
      this.selectedFileName = "";
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h5 {
  margin: 0;
  font-weight: 600;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
